import Service from "../Service";

const resource = "TrainingParticipant/";

export default {
  list(filter, requestID) {
    return Service.post(resource + "list", filter, {
      params: { requestID },
    });
  },
  save(obj, requestID) {
    return Service.post(resource + "save", obj, {
      params: { requestID },
    });
  },
  bulkArea(payload, requestID) {
    return Service.post(resource + "bulkArea", payload, {
      params: { requestID },
    });
  },
  bulkPosition(payload, requestID) {
    return Service.post(resource + "bulkPosition", payload, {
      params: { requestID },
    });
  },
  mobileByDocument(prsDocumentNumber, requestID) {
    return Service.get(resource + "mobile/byDocument", {
      params: { PrsDocumentNumber: prsDocumentNumber, requestID },
    });
  },
  mobileSaveResponse(payload, requestID) {
    return Service.post(resource + "mobile/saveResponse", payload, {
      params: { requestID },
    });
  },
  getCoverage(filter, requestID) {
    return Service.post(resource + "dashboard/coverage", filter, {
      params: { requestID },
    });
  },
  saveSurvey(payload, requestID) {
    return Service.post(resource + "survey/save", payload, {
      params: { requestID },
    });
  },
  listSurveys(filter, requestID) {
    return Service.post(resource + "survey/list", filter, {
      params: { requestID },
    });
  },
  summarySurvey(filter, requestID) {
    return Service.post(resource + "survey/summary", filter, {
      params: { requestID },
    });
  },
};
